<script lang="ts">
    import { browser } from '$app/environment';
    import TrackBrowserEvents from './TrackBrowserEvents/TrackBrowserEvents.svelte';
    import SetupBrowerTracking from './SetupBrowserTracking/SetupBrowerTracking.svelte';
</script>

{#if browser}
    <SetupBrowerTracking />
    <TrackBrowserEvents />
{/if}
